import Flickity from 'flickity'
import 'flickity-imagesloaded'
import throttle from 'lodash/throttle'
import { isElementInViewport } from './utils';

function setCellHeight() {
	this.cells.forEach(cell => cell.element.style.height = '');

	const heights = this.cells.map(cell => cell.element.offsetHeight)
	const max = Math.max(...heights)

	this.cells.forEach(cell => cell.element.style.height = max + 'px');
}

const sliders = new Map()

document.querySelectorAll('[data-slider]').forEach($slider => {
	const options = $slider.dataset.slider.startsWith('{') ? JSON.parse($slider.dataset.slider) : {}

	const flkty = new Flickity($slider, {
		contain: true,
		cellAlign: 'left',
		pageDots: false,
		imagesLoaded: true,
		arrowShape: {
			x0: 25,
			x1: 55, y1: 30,
			x2: 60, y2: 25,
			x3: 35
		},
		on: {
			ready: function () {
				// transfer row classnames to slider element
				const regex = /g-[0-9a-z]|row(?:-cols-(?:[a-z]{2}-)?[1-9])?/g
				const match = this.element.getAttribute('class').match(regex)
				if (match?.length) {
					this.element.classList.remove(...match)
					this.slider.classList.add(...match)
				}

				setCellHeight.call(this)

				// check if the slider somehow conveys it can be interacted with
				const hasNoAffordance = this.options.prevNextButtons === false &&
					this.options.pageDots === false &&
					this.options.autoPlay != true

				// do a slide animation when slider comes into viewport
				if (hasNoAffordance && !isElementInViewport(this.element)) {
					this.previous(false, true)

					const handleScroll = throttle(() => {
						if (isElementInViewport(this.element)) {
							this.next()
							window.removeEventListener('scroll', handleScroll)
						}
					}, 100, { leading: true })

					window.addEventListener('scroll', handleScroll)
					handleScroll()
				}

				// Custom option that loops the slider by cloning its cells.
				// Works in tandem with the`settle` event.
				if (this.options.loop) {
					const cellElements = this.cells.map(cell => cell.element)
					const clonedElements = []

					for (let index = 1; index < this.options.loop; index++) {
						clonedElements.push(
							...cellElements.map(element => element.cloneNode(true))
						)
					}

					this.append(clonedElements)
				}
			},
			resize: setCellHeight,
			staticClick: function (event, pointer, element, cellIndex) {
				this.select(cellIndex)
			},
			select: function () {
				// Trigger click if current slider cell is a tab
				const tab = this.selectedElement.querySelector('[data-bs-toggle="tab"]:not(.active)')
				if (tab) tab.click()
			},
			settle: function (index) {
				// Loop back to previous cell when the current index is equal to or
				// larger than twice the orinal cell count.
				if (this.options.loop) {
					const originalCellCount = this.cells.length / this.options.loop

					if (index >= originalCellCount * 2) {
						const cellOffset = index - (originalCellCount * 2)
						this.select(originalCellCount + cellOffset, false, true)
					}
				}

				// Restart autoPlay
				if (this.options.autoPlay) {
					this.playPlayer()
				}
			}
		},
		...options
	})

	sliders.set($slider, flkty)
})

window.addEventListener('load', () => {
	sliders.forEach(flkty => flkty.resize())
})
